import { render, staticRenderFns } from "./SendNotificationDialog.vue?vue&type=template&id=4c4c8e2c&scoped=true"
import script from "./SendNotificationDialog.vue?vue&type=script&lang=js"
export * from "./SendNotificationDialog.vue?vue&type=script&lang=js"
import style0 from "./SendNotificationDialog.vue?vue&type=style&index=0&id=4c4c8e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c8e2c",
  null
  
)

export default component.exports